'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t;

import React from 'react';
import { useSelector } from 'react-redux';
import { ENTERPRISE, orderedProductLevels, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { calculatedPriceSelector } from '../../selectors/PricingSelectors';
import { currentSkuIdForProductSelector } from '../../selectors/ProductsSelectors';
import ProductLevelSelectionButton from './ProductLevelSelectionButton';
import UnavailableProductLevelButton from './UnavailableProductLevelButton';
import styled from 'styled-components';
import breakpoint from '../../utils/responsiveBreakpoints';
const ResponsiveFlex = styled.div.withConfig({
  displayName: "HubProductLevelPicker__ResponsiveFlex",
  componentId: "sc-1rstv64-0"
})(["display:flex;flex-direction:row;", ""], breakpoint.phone(_t || (_t = _`
    flex-direction: column;
  `)));

const ProductLevelSelectionButtonContainer = (_ref) => {
  let {
    productLine,
    productLevel
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["productLine", "productLevel"]);

  const skuId = useSelector(state => currentSkuIdForProductSelector(state, {
    productLine,
    productLevel
  }));
  const price = useSelector(state => skuId && calculatedPriceSelector(state, {
    productConfigurations: [createProductConfig({
      skuId
    })]
  }));
  if (!skuId) return /*#__PURE__*/_jsx(UnavailableProductLevelButton, {});
  const monthlyPrice = price && price.monthly.fullPrice;
  return /*#__PURE__*/_jsx(ProductLevelSelectionButton, Object.assign({
    productLine: productLine,
    productLevel: productLevel,
    price: monthlyPrice
  }, rest));
};

const HubProductLevelPicker = ({
  productLine,
  ownedProductLevel,
  disabledProductLevel,
  selectedProductLevel,
  required,
  setSelectedProductLevel
}) => {
  return /*#__PURE__*/_jsx(ResponsiveFlex, {
    children: [STARTER, PROFESSIONAL, ENTERPRISE].map(productLevel => {
      return /*#__PURE__*/_jsx(ProductLevelSelectionButtonContainer, {
        productLine: productLine,
        productLevel: productLevel,
        selected: selectedProductLevel === productLevel,
        disabled: orderedProductLevels.indexOf(disabledProductLevel) >= orderedProductLevels.indexOf(productLevel),
        isCurrentPlan: ownedProductLevel === productLevel,
        onClick: () => {
          if (selectedProductLevel !== productLevel) setSelectedProductLevel(productLevel);else if (!required) setSelectedProductLevel(null);
        }
      }, productLevel);
    })
  });
};

export default HubProductLevelPicker;